import { useState } from "react";
import { __ } from '@wordpress/i18n';
import TemplateForm from "./template-form";
import { createTemplate, getTemplateName, updateTemplate } from "./helper";
import { TemplateLists } from "jkit-core/control";
import { dispatch } from '@wordpress/data';
import { store } from 'jkit-core/store';



const wrapperStyle = {
    display: "flex",
    flexDirection: "column"
};



export default function TemplatesContent({ templates, desc, menuTitle, activeMenu }) {
    const [activeTab, setActiveTab] = useState('publish');
    const [items, setItems] = useState(templates);

    const [isOpen, setIsOpen] = useState(false);
    const [editData, setEditData] = useState(false);
    const isEmpty = items['publish'].length + items['draft'].length == 0;

    const updateTemplateLists = (data) => {
        dispatch(store).setTemplate({
            key: activeMenu,
            value: data
        });
        setItems(data)
    }

    const openCreateForm = () => {
        setEditData(false);
        setIsOpen(true);
    };

    const openEditForm = (index, item) => {
        setEditData({
            index: index,
            ...item
        });
        setIsOpen(true);


    };
    const handleSubmit = async (data) => {
        const params = {
            type: getTemplateName(activeMenu),
            data: {
                ...data,
                type: activeMenu,
            },
        }
        if (editData) {
            await updateTemplate(params).then(res => {
                if (res) {
                    let updatedLists = [...items[activeTab]];
                    updatedLists[editData.index] = {
                        ...editData,
                        condition: data.condition,
                        title: data.title
                    };
                    let newList = {
                        ...items,
                        [activeTab]: updatedLists
                    };
                    updateTemplateLists(newList)
                }
                setEditData(false);

            });
        } else {
            await createTemplate(params).then(res => {
                if (res) {
                    updateTemplateLists(res.data)
                }
                setEditData(false);
            });
        }
        setIsOpen(false);
    };
    if (isEmpty) {
        return <div style={wrapperStyle}>
            <div className="template-lists">
                <div className="template-header empty">
                    <div className="header-desc">
                        <h3>{__('Create ', 'jeg-elementor-kit') + menuTitle}</h3>
                        <p>{desc['empty']}</p>
                    </div>
                    <div className="header-action">
                        <div onClick={() => openCreateForm()} className="add-button"> {__('+ Add ', 'jeg-elementor-kit') + menuTitle}</div>
                    </div>
                </div>
            </div>
            <TemplateForm
                key={editData?.id || 'new'}
                menuTitle={menuTitle}
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                onSubmit={handleSubmit}
                data={editData}
                activeMenu={activeMenu}
            />
        </div>
    }

    return (
        <div style={wrapperStyle}>
            <div className={`template-lists ${activeTab}`}>
                <div className="template-header">
                    <div className="header-desc">
                        <h3>{(activeTab === 'draft') ? 'Inactive' : 'Active'} {__('Template', 'jeg-elementor-kit')}</h3>
                        <p>{desc[activeTab]}</p>
                    </div>
                    <div className="header-action">
                        <div className="active-tabs">
                            <div onClick={() => setActiveTab('publish')} className={`tabs-button ${activeTab === 'publish' ? 'active' : ''}`}>
                                {__('Active', 'jeg-elementor-kit')}
                                <span>{`(${items.publish.length})`}</span>
                            </div>
                            |
                            <div onClick={() => setActiveTab('draft')} className={`tabs-button ${activeTab === 'draft' ? 'active' : ''}`}>
                                {__('Inactive', 'jeg-elementor-kit')}
                                <span>{`(${items.draft.length})`}</span>
                            </div>
                        </div>
                        <div onClick={() => openCreateForm()} className="add-button"> {__('+ Add ', 'jeg-elementor-kit') + menuTitle}</div>
                    </div>
                </div>

                {(activeTab === 'draft') ? (
                    <ul className="list-heading">
                        <li className="name">{__('Template Name', 'jeg-elementor-kit')}</li>
                        <li className="status">{__('Status', 'jeg-elementor-kit')}</li>
                        <li className="edit">{__('Edit', 'jeg-elementor-kit')}</li>
                        <li className="delete">{__('Delete', 'jeg-elementor-kit')}</li>
                    </ul>
                ) : (
                    <ul className="list-heading">
                        <li className="name">{__('Template Name', 'jeg-elementor-kit')}</li>
                        <li className="priority">{__('Priority', 'jeg-elementor-kit')}</li>
                        <li className="status">{__('Status', 'jeg-elementor-kit')}</li>
                        <li className="setting">{__('Setting', 'jeg-elementor-kit')}</li>
                        <li className="edit">{__('Edit', 'jeg-elementor-kit')}</li>
                        <li className="clone">{__('Clone', 'jeg-elementor-kit')}</li>
                        <li className="delete">{__('Delete', 'jeg-elementor-kit')}</li>
                    </ul>
                )}
                <TemplateLists items={items} activeTab={activeTab} templates={items[activeTab]} setTemplates={updateTemplateLists} openEditForm={openEditForm} activeMenu={activeMenu} />
            </div>
            <TemplateForm
                key={editData?.id || 'new'}
                menuTitle={menuTitle}
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                onSubmit={handleSubmit}
                data={editData}
                activeMenu={activeMenu}
            />
        </div>
    );
}
